import React from 'react'
import { View, StyleSheet, Linking } from 'react-native'
import { ContentContainer, ScrollableDialog } from '../../dialogs/CustomDialog'
import { CustomText } from '../../text/StyledText'
import { txt } from '../../../locales/i18n'
import { ButtonPrimary } from '../../buttons/StyledButtons'
import Colors from '../../../constants/Colors'
import CustomPressable from "../../pressables/CustomPressable"

export default function BehaviorDialog({ onPress, visible, close }) {
  return (
    <View>
      <CustomPressable onPress={onPress} style={styles.descriptionText}>
        <CustomText font="smallBold" style={{ marginBottom: 20 }}>
          {txt('videoChat.help.label')}
        </CustomText>
      </CustomPressable>

      <ScrollableDialog visible={visible}>
        <ContentContainer>
          <CustomText style={{ fontSize: 20, fontFamily: 'raleway-semibold', marginVertical: 12 }}>
            {txt('videoChat.help.label')}
          </CustomText>
          <CustomText>
            {txt('videoChat.help.description1')}
            <CustomPressable onPress={() => Linking.openURL('mailto:support@snaksammen.dk')}>
              <CustomText style={styles.linkText}>{txt('videoChat.help.supportMail')}</CustomText>
            </CustomPressable>
            {txt('videoChat.help.description2')}
          </CustomText>
        </ContentContainer>
        <View style={{ paddingBottom: 16 }}>
          <ButtonPrimary
            onPress={close}
            style={{ backgroundColor: Colors.blueAzure }}
            title={txt('global.close')}
            titleStyle={{ paddingHorizontal: 12 }}
          />
        </View>
      </ScrollableDialog>
    </View>
  )
}

const styles = StyleSheet.create({
  descriptionText: {
    alignSelf: 'center',
    textAlign: 'center',
    marginTop: 12,
  },
  linkText: {
    color: Colors.tintColor,
  },
})
